import { Grid } from "@mui/material";
import CustomSelect from "../../../../../../../../components/CustomSelect";
import Input from "../../../../../../../../components/Input";
import { PatientVital } from "../../../../../../../../services";
import {
  FLAG_OPTS,
  ORAL_OPTS,
  TEMPERATURE_OPTS,
  VitalFormik,
} from "../vital-constant";

interface TemperatureFieldsProps {
  formik: VitalFormik;
  ind: number;
}

const TemperatureFields = ({ formik, ind }: TemperatureFieldsProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  const selectHandleChange = (k: keyof PatientVital, v: string | null) => {
    formik.setFieldValue(getKey(k), v);
  };

  return (
    <Grid
      container
      sx={{
        gap: 2,
      }}
    >
      <Grid size={1.8}>
        <CustomSelect
          name={getKey("unit")}
          label="Unit"
          placeholder="F"
          required={isSelected}
          error={getError("unit")}
          options={TEMPERATURE_OPTS}
          value={activeVital?.unit}
          onChange={(v) => selectHandleChange("unit", v)}
          handleBlur={formik.handleBlur}
        />
      </Grid>
      <Grid size={2.6}>
        <Input
          required={isSelected}
          error={getError("value")}
          textFieldProps={{
            name: getKey("value"),
            placeholder:
              activeVital?.unit === "c" ? "e.g. 37 (°C)" : "e.g. 98.6 (°F)",
            value: activeVital?.value,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
          }}
        />
      </Grid>
      <Grid size={2.6}>
        <CustomSelect
          name={getKey("method")}
          label="Method"
          placeholder="Select Method"
          required={isSelected}
          error={getError("method")}
          options={ORAL_OPTS}
          value={activeVital?.method}
          onChange={(v) => selectHandleChange("method", v)}
          handleBlur={formik.handleBlur}
        />
      </Grid>
      <Grid size={1.8}>
        <CustomSelect
          name={getKey("flag")}
          label="Flag"
          placeholder="flag"
          required={isSelected}
          error={getError("flag")}
          options={FLAG_OPTS}
          value={activeVital?.flag}
          onChange={(v) => selectHandleChange("flag", v)}
          handleBlur={formik.handleBlur}
        />
      </Grid>
    </Grid>
  );
};

export default TemperatureFields;
